<div class="image-popup" style="width: 800px; min-height: 400px;">
  <app-image width="800" [key]="image"></app-image>
  <span class="title" [innerHTML]="title"></span>
</div>
